import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { ScrollToService } from 'app/shared/scroll-to.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { MathtagService } from 'app/shared/analytics/mathtag/mathtag.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';
import { environment } from '../../../../environments/environment';

import { DadosVestibular } from 'models/dados-vestibular';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './finalizacao.component.html',
  styleUrls: ['./finalizacao.component.scss'],
  animations: [routerTransition],
})
export class FinalizacaoComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosVestibular: DadosVestibular = undefined;
  dadosVestibularSubscription: Subscription;
  isReingresso = false;
  environment = environment;

  constructor(
    private router: Router,
    private fluxoVestibularService: FluxoVestibularService,
    private scrollTo: ScrollToService,
    private analytics: AnalyticsService,
    private mathtag: MathtagService,
  ) { }

  ngOnInit() {
    this.scrollTo.goTop();

    this.limparDadosMarketPlace();

    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    if (!this.dadosVestibular.vestibular) {

      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
      });

    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Finalização da inscrição',
      );
    }

    // add reemarketing track
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.inscricaoFinalizacao();
    }
  }

  init() {
    if (this.dadosVestibular && this.dadosVestibular.vestibular) {
      this.isReingresso = this.dadosVestibular.vestibular.isReingresso;
    }
  }

  ngOnDestroy() {
    // remove script Remarketing
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.removerTodosScripts();
    }
  }

  acessarProvaOnline(){
    window.location.href=`https://redacaodigital.grupoceuma.com.br/course/view.php?id=3&username=${this.dadosVestibular.candidato.email}`;
  }


  limparDadosMarketPlace(){
    if(sessionStorage.getItem("marketPlaceData") != null){
      sessionStorage.setItem("byMarketPlace", "true");
      sessionStorage.setItem("marketPlaceData", null);

    }
  }

}
